import { Box, Typography } from '@mui/material';

import PonduranceLogo from '@/assets/pondurance-logo-white.png'; // red+black version
import headerBg from '@/assets/report-header-wave-2.png'; // optional textured BG

import useStyles from './PDFTemplate.styles';
import type { PDFHeaderProps } from './PDFTemplate.types';

const PDFHeader = ({
  title,
  clientLabel,
  dateLabel,
  sectionLabel = 'EXECUTIVE SUMMARY'
}: PDFHeaderProps) => {
  const { classes } = useStyles();

  return (
    <>
      {/* Top Banner */}
      <Box className={classes.headerWrapper}>
        {/* Overlayed image */}
        <Box
          component="img"
          src={headerBg}
          alt="Wave overlay"
          className={classes.headerImage}
        />

        {/* Content layer */}
        <Box className={classes.headerContent}>
          <Box>
            <Typography variant="h4" className={classes.headerTitle}>
              {title}
            </Typography>
            <Typography variant="subtitle2" className={classes.headerSubText}>
              {clientLabel}
            </Typography>
            <Typography variant="subtitle2" className={classes.headerSubText}>
              {dateLabel}
            </Typography>
          </Box>
          <img src={PonduranceLogo} alt="Pondurance" height={60} />
        </Box>
      </Box>

      {/* Section Bar */}
      <Box className={classes.sectionBar}>
        <Typography className={classes.sectionLabel}>{sectionLabel}</Typography>
      </Box>
    </>
  );
};

export default PDFHeader;
